/* -------------------------------------------------------------------------- */
// react-hook-form RegisterOptions
/* -------------------------------------------------------------------------- */
const useValidator = () => {
  /* -------------------------------------------------------------------------- */
  // 이메일 체크 유틸리티
  /* -------------------------------------------------------------------------- */
  const validateEmail = {
    required: '이메일은 필수 입력입니다.',
    pattern: {
      value: /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i,
      message: '이메일 형식에 맞지 않습니다.'
    }
  };

  /* -------------------------------------------------------------------------- */
  // 패스워드 체크 유틸리티
  // ▸ 8 ~ 16자 — 영문, 숫자, 특수문자 최소 한가지 조합
  /* -------------------------------------------------------------------------- */
  const validatePassword = {
    required: '비밀번호는 필수 입력입니다.',
    pattern: {
      value: /^(?=.*[a-zA-z])(?=.*[0-9])(?=.*[$\`~!@$!%*#^?&\\(\\)\-_=+]).{8,16}$/,
      message: '비밀번호는 영문, 숫자, 특수문자 조합 8자리 이상 16자리 미만으로 입력해야 합니다.'
    }
  };

  /* -------------------------------------------------------------------------- */
  // 패스워드 확인 체크 유틸리티
  // 사용 ▸ validatePasswordConfirm(getValues('password'))
  /* -------------------------------------------------------------------------- */
  const validatePasswordConfirm = (passwordVal) => {
    return {
      required: '비밀번호 확인은 필수 입력입니다.',
      validate: {
        check: (val) => {
          // console.log(passwordVal, val);
          if (passwordVal !== val) {
            return '비밀번호가 일치하지 않습니다.';
          }
        }
      }
    };
  };

  /* -------------------------------------------------------------------------- */
  // 닉네임 체크 유틸리티
  /* -------------------------------------------------------------------------- */
  const validateNickname = {
    required: '닉네임은 필수 입력입니다.',
    minLength: {
      value: 2,
      message: '2자리 이상 입력해주세요.'
    }
  };

  return {
    validateEmail,
    validatePassword,
    validatePasswordConfirm,
    validateNickname
  };
};

export default useValidator;
